import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import FlagTwoToneSvg from "@ant-design/icons-svg/es/asn/FlagTwoTone";
import AntdIcon from "../components/AntdIcon";
var FlagTwoTone = function FlagTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FlagTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  FlagTwoTone.displayName = 'FlagTwoTone';
}
export default /*#__PURE__*/React.forwardRef(FlagTwoTone);